import React, { useEffect, useState } from "react";
import Map from "./Map";
import Address from "./Address";
import Form from "./Form";
import Preheader from "../KalHome/Preheader";
import Header from "../KalHome/Header";
import Footer from "../Homecomponents/Footer";
import Newsletter from "../Homecomponents/Newsletter";
import Endfooter from "../Homecomponents/Endfooter";
import Superheader from "../KalHome/Superheader";

const Maincontact = () => {
    const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50); // Adjust threshold as needed
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <>
      {/* <Preheader /> */}
      <Superheader />
      <div className={isSticky ? "header-wrapper sticky" : "header-wrapper"}>
        <Header />
      </div>
      <Map />
      <Address />
      <Form />
      <Newsletter />
      <Footer />
      <Endfooter />
    </>
  );
};

export default Maincontact;
